import { createRequire } from "module";
import { j as json } from "../../../../chunks/index.js";
const require2 = createRequire(import.meta.url);
const { PrismaClient } = require2("@prisma/client");
const prisma = new PrismaClient();
async function GET() {
  try {
    const brands = await prisma.brand.findMany({
      where: {
        isActive: true
        // Only fetch active brands
      }
    });
    return new Response(JSON.stringify(brands), {
      status: 200,
      headers: {
        "Content-Type": "application/json"
      }
    });
  } catch (error) {
    console.error("Error fetching brands:", error);
    return new Response("Error fetching brands", { status: 500 });
  } finally {
    await prisma.$disconnect();
  }
}
const POST = async ({ request }) => {
  const { name, imageUrl } = await request.json();
  try {
    const brand = await prisma.brand.create({
      data: {
        name,
        imageUrl
      }
    });
    return json(brand, { status: 201 });
  } catch (error) {
    console.error("Error creating brand:", error);
    return json({ error: "Failed to create brand" }, { status: 500 });
  }
};
export {
  GET,
  POST
};
